<template>
    <div v-if="images.length > 0" id="myCarouselContainer">
  
      <div id="myCarousel" class="carousel slide" :class="fullscreen ? 'fullscreen' : ''" data-interval="false">
        <div class="carousel-minimize" @click="fullscreen = false"><Icon icon="ri:close-fill" height="25" /></div>
       
        <!-- <i class="mdi mdi-close carousel-minimize" @click="fullscreen = false"></i> -->
        <div class="carousel-count"><span class="start">1</span>/<span class="end">{{images.length}}</span></div>
        <div class="carousel-container">
          <div class="carousel-inner mb-3">
  
            <div v-for="(item, item_i) in images" :key="item_i" class="carousel-item border border-light" :class="item_i == 0 ? 'active' : ''" :data-slide-number="item_i">
              <img :src="item && item.location ? formatImage(item.location) : item ? formatImage(item) : '/images/no-image.jpg'" class="img-fluid" @click="toggleFullscreen">
            </div>
            
            <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
          <ul class="carousel-indicators list-inline mx-auto">
            <li v-for="(item, item_i) in images" :key="item_i" :class="item_i == 0 ? 'active' : ''" class="list-inline-item border border-light">
              <a :id="'carousel-selector-'+item_i" :class="item_i == 0 ? 'selected' : ''" :data-slide-to="item_i" data-target="#myCarousel">
                <img :src="item && item.location ? formatImage(item.location) : item ? formatImage(item) : '/images/no-image.jpg'" class="img-fluid">
              </a>
            </li>
          </ul>
        </div>
      </div>
  
    </div>
  </template>
  
  <script type="text/javascript">
  
    export default {
      props: ['images'],
      data() {
        return {
          fullscreen: false,
        }
      },
      mounted() {
        // $('#myCarouselContainer').on('slide.bs.carousel', '#myCarousel', function (e) {
        //   console.log("sliding");
        //   $(this).find(".start").html(e.to+1);
        //   var cont = $(this).find(".carousel-indicators");
        //   var el = $(cont[0].children[e.to]);
        //   var h = cont.width() / 2 - el.width() / 2;
        //   var pl = el.position().left;
        //   var pos = cont.scrollLeft() + pl - h;
        //   cont.animate({scrollLeft: pos}, 800);
        // });
      },
      beforeMount () {
        window.addEventListener('keydown', this.handleKeydown, null);
      },
      beforeDestroy () {
        window.removeEventListener('keydown', this.handleKeydown);
      },
      created() {
  
      },
      methods: {
        toggleFullscreen() {
          if(!this.fullscreen) { this.fullscreen = true; }
          else { this.fullscreen = false; }
        },
        handleKeydown (e) {
          e = e || window.event;
          if(e.keyCode == '37') {
            $('#myCarousel').carousel('prev');
          } else if(e.keyCode == '39') {
            $('#myCarousel').carousel('next');
          } else if(e.keyCode == '27') {
            this.fullscreen = false;
          }
        }
      }
    }
  </script>
  
  <style>
  #myCarousel {
    position: relative;
    padding-top: calc(100% + 140px);
    color: #fff;
    -webkit-transition:all .4s ease-in-out; -moz-transition:all .4s ease-in-out; transition:all .4s ease-in-out;
  }
  #myCarousel.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    background: rgba(0,0,0,0.8);
    z-index: 2000;
  }
  #myCarousel .carousel-count {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 500;
  }
  #myCarousel.fullscreen .carousel-count {
    top: 70px;
  }
  #myCarousel .carousel-minimize {
    position: absolute;
    right: 10px;
    top: 70px;
    padding: 15px;
    color: #fff;
    background: rgba(0,0,0,0.4);
    z-index: 500;
    display: none;
    cursor: pointer;
    -webkit-transition:all .2s ease-in-out; -moz-transition:all .2s ease-in-out; transition:all .2s ease-in-out;
  }
  #myCarousel .carousel-minimize:hover {
    background: rgba(0,0,0,1);
  }
  #myCarousel.fullscreen .carousel-minimize {
    display: inline-block;
  }
  #myCarousel .carousel-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    -webkit-transition:all .4s ease-in-out; -moz-transition:all .4s ease-in-out; transition:all .4s ease-in-out;
  }
  #myCarousel.fullscreen .carousel-container {
    margin: 70px 10px 0px 10px;
    /* margin-bottom: 0px; */
  }
  #myCarousel .carousel-inner {
    height: calc(100% - 140px);
    white-space:nowrap;
  }
  #myCarousel .carousel-inner .carousel-item {
    height: 100%;
    text-align: center;
  }
  #myCarousel .carousel-inner .carousel-item img {
    border-radius: 0px;
    /* height: 100%;
    width: auto; */
    cursor: zoom-in;
    max-height: 100%;
    max-width: 100%;
    width: auto;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
    -webkit-transition:all .4s ease-in-out; -moz-transition:all .4s ease-in-out; transition:all .4s ease-in-out;
  }
  #myCarousel.fullscreen .carousel-inner .carousel-item img {
    height: 100%;
    width: auto;
  }
  #myCarousel .carousel-indicators {
    height: 130px;
    display: block;
    margin-bottom: 0;
    white-space: nowrap;
    overflow-x: auto;
  }
  #myCarousel .carousel-indicators > li {
    width: initial;
    height: initial;
    text-indent: initial;
    background: transparent;
  }
  #myCarousel .carousel-indicators > li:first-child {
    margin-left: 0px;
  }
  #myCarousel .carousel-indicators > li:last-child {
    margin-right: 0px;
  }
  #myCarousel .carousel-indicators > li img {
    height: 100px;
    width: auto;
    border-radius: 4px;
  }
  #myCarousel .carousel-indicators > li.active img {
  
  }
  #myCarousel .carousel-control-prev, #myCarousel .carousel-control-next {
    opacity: 0.9;
  }
  #myCarousel .carousel-control-prev .carousel-control-prev-icon, #myCarousel .carousel-control-next .carousel-control-next-icon {
    filter: invert(50%);
  }
  #myCarousel .carousel-control-prev:hover, #myCarousel .carousel-control-prev:focus, #myCarousel .carousel-control-next:hover, #myCarousel .carousel-control-next:focus {
    opacity: 1;
  }
  @media only screen and (max-width: 768px) {
    #myCarousel {
      padding-top: calc(62% + 0px);
    }
    #myCarousel .carousel-inner {
      height: calc(100% - 0px);
    }
    #myCarousel .carousel-indicators {
      display: none;
    }
  }
  </style>
  